






























































































import { Component, Watch, Mixins, Prop } from 'vue-property-decorator';
import BaseMixin from '../../mixins/BaseMixin';
import OrderStateToolTip from '@/components/order-state-tooltip/OrderStateToolTip.vue';
import { PartSearchResultDetails } from '@/entities/PartSearchResultDetails';
import ShoppingCartActions from '@/components/shopping-cart/ShoppingCartActions.vue';
import Price from '@/components/price/Price.vue';
import PartSearchCardImage from '@/components/part-search/PartSearchCardImage.vue';
import DeliveryTimeToolTip from '@/components/delivery-time-tooltip/DeliveryTimeToolTip.vue';
import { result } from 'lodash/fp';

@Component({
    components: {
        ShoppingCartActions,
        Price,
        PartSearchCardImage,
        DeliveryTimeToolTip,
    },
})
export default class PartListItem extends Mixins(BaseMixin) {
    @Prop(Object)
    private result!: PartSearchResultDetails;
    @Prop(String)
    private partDetailLink!: string;
    @Prop(Boolean)
    private showImage!: boolean;

    private showAvailability: boolean = true;

    private get maxAllowedQuantity(): number | undefined {
        if (!this.result.searchResult.isUsedPart) {
            return undefined;
        }

        return this.getAvailableItemCount();
    }

    private onQuantityValid(): void {
        this.showAvailability = true;
    }

    private onQuantityInvalid(): void {
        this.showAvailability = false;
    }

    private getAvailableItemCount(): number {
        if (!this.result.partAvailability || !this.result.partAvailability.stockInfos) {
            return 0;
        }
        return this.result.partAvailability.stockInfos
            .map((info) => info.quantity)
            .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    }
}
